module.exports = __webpack_public_path__ + "img/help-center-active.e4fec194.svg";